import { Modal, Select } from '@automata/ui';
import { env } from '@automata/utils';
import { useFlag } from '@automata/utils/hooks';
import { MenuItem } from '@mui/material';

import { selectSelectedWorkcellId } from '../../../../features/workflow/selectors';
import { setSelectedWorkcellId } from '../../../../features/workflow/workflowSlice';
import { useAppDispatch, useAppSelector } from '../../../../hooks';
import {
  HARDCODED_WORKCELL_OPTIONS,
  isSelectedWorkcellId,
} from '../../../../hooks/useGetWorkcell/types';

type Props = {
  onClose: () => void;
};

export const SelectWorkcellIdModal = ({ onClose }: Props) => {
  const selectedWorkcellId = useAppSelector(selectSelectedWorkcellId);
  const dispatch = useAppDispatch();

  const isProdEnv = env('NEXT_PUBLIC_ENV') === 'prod';
  const allowOnlyDefaultWorkcellInDevMode = useFlag(
    'fe.allow_only_default_workcell_in_dev_mode'
  );

  const availableWorkcellOptions =
    isProdEnv || allowOnlyDefaultWorkcellInDevMode
      ? HARDCODED_WORKCELL_OPTIONS.filter(
          (option) => option.id === selectedWorkcellId
        )
      : HARDCODED_WORKCELL_OPTIONS;

  return (
    <Modal open onClose={onClose} title="Select workcell">
      <Select
        value={selectedWorkcellId}
        onChange={(e) => {
          const value = e.target.value;
          if (isSelectedWorkcellId(value)) {
            dispatch(setSelectedWorkcellId(value));
            onClose();
          }
        }}
      >
        {availableWorkcellOptions.map(({ id, name }) => (
          <MenuItem key={id} value={id}>
            {name}
          </MenuItem>
        ))}
      </Select>
    </Modal>
  );
};
